import React from 'react';

const QuarterRest = ({ x, y, width, height }) => {
  // This path is an approximation of a quarter rest symbol
  // It's designed in a 10x40 box for easy scaling
  const pathData = `
    M 0 0 
    L 4 10 
    L 0 20 
    L 4 30 
    L 0 40 
  `;

  return (
    <g
      transform={`translate(${x}, ${y}) scale(${width / 10}, ${height / 40})`}
      fill="none"
      stroke="black"
      strokeWidth="2"
    >
      <path d={pathData} />
    </g>
  )
}

export default QuarterRest